import { render, staticRenderFns } from "./itemProduct.vue?vue&type=template&id=c66a9592&scoped=true"
import script from "./itemProduct.vue?vue&type=script&lang=js"
export * from "./itemProduct.vue?vue&type=script&lang=js"
import style0 from "./itemProduct.vue?vue&type=style&index=0&id=c66a9592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66a9592",
  null
  
)

export default component.exports